import { render, staticRenderFns } from "./SMSLength.vue?vue&type=template&id=23542d07"
import script from "./SMSLength.vue?vue&type=script&lang=js"
export * from "./SMSLength.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports